/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * The reason for not reusing transaction_ocr from "#/components/schemas/ReceivedInvoiceDetail" is to keep the status display logic out of the frontend and to make it easier to add or remove statuses through the enum when displaying or managing automatic input statuses other than transaction_ocr.
"processing" includes the statuses for invoice header OCR, AI suggestions, and line-item OCR. The usage for invoice header OCR and AI suggestions can be controlled at the aweb, office, and ap_payee levels, so this logic needs to be handled by the backend.
null indicates that the status does not need to be displayed.

 */
export type SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfAutomaticProcessingStatus =

    | (typeof SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfAutomaticProcessingStatus)[keyof typeof SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfAutomaticProcessingStatus]
    | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfAutomaticProcessingStatus =
  {
    processing: 'processing',
    transaction_ocr_success: 'transaction_ocr_success',
    transaction_ocr_failure: 'transaction_ocr_failure',
  } as const;
